/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { SchedulingScheduleTemplateBusinessService } from '../../resources/scheduling-schedule-template-business.service';

import { SchedulingScheduleTemplateDetailsDialogComponent } from './scheduling-schedule-template-details-dialog.component';

export const createScheduleTemplateDialog = createDialogRoute({
  component: SchedulingScheduleTemplateDetailsDialogComponent,
  init: SchedulingScheduleTemplateBusinessService,
});
